<template>
  <div ref="progress" class="flex items-center justify-center w-full cursor-pointer">
    <svg
      ref="svg"
      width="183"
      height="44"
      viewBox="0 0 183 44"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath :id="`clipPath-${contentId}`">
          <rect :x="`${progress}%`" y="0" width="183" height="100" />
        </clipPath>
      </defs>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle :fill="color" cx="1.68" cy="21.42" r="1.68" />
        <circle :fill="color" cx="6.044" cy="21.42" r="1.68" />
        <circle :fill="color" cx="10.408" cy="21.42" r="1.68" />
        <circle :fill="color" cx="45.319" cy="21.42" r="1.68" />
        <circle :fill="color" cx="49.683" cy="21.42" r="1.68" />
        <circle :fill="color" cx="54.047" cy="21.42" r="1.68" />
        <circle :fill="color" cx="58.411" cy="21.42" r="1.68" />
        <circle :fill="color" cx="67.139" cy="21.42" r="1.68" />
        <circle :fill="color" cx="97.686" cy="21.42" r="1.68" />
        <circle :fill="color" cx="102.05" cy="21.42" r="1.68" />
        <circle :fill="color" cx="106.414" cy="21.42" r="1.68" />
        <circle :fill="color" cx="110.778" cy="21.42" r="1.68" />
        <circle :fill="color" cx="119.505" cy="21.42" r="1.68" />
        <circle :fill="color" cx="145.689" cy="21.42" r="1.68" />
        <circle :fill="color" cx="150.053" cy="21.42" r="1.68" />
        <circle :fill="color" cx="167.508" cy="21.42" r="1.68" />
        <circle :fill="color" cx="171.872" cy="21.42" r="1.68" />
        <circle :fill="color" cx="180.6" cy="21.42" r="1.68" />
        <rect :fill="color" x="13.092" y="18.06" width="3.36" height="7.14" rx="1.68" />
        <rect :fill="color" x="30.547" y="18.06" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="color" x="39.275" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="color" x="61.095" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="color" x="113.461" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="color" x="130.917" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="color" x="139.645" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="color" x="152.737" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="color" x="161.464" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="color" x="174.556" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="color" x="135.281" y="16.38" width="3.36" height="9.24" rx="1.68" />
        <rect :fill="color" x="157.1" y="16.8" width="3.36" height="9.24" rx="1.68" />
        <rect :fill="color" x="34.911" y="16.8" width="3.36" height="9.66" rx="1.68" />
        <rect :fill="color" x="17.456" y="9.66" width="3.36" height="23.94" rx="1.68" />
        <rect :fill="color" x="21.82" y="13.86" width="3.36" height="15.12" rx="1.68" />
        <rect :fill="color" x="26.183" y="3.78" width="3.36" height="35.28" rx="1.68" />
        <rect :fill="color" x="69.822" y="9.66" width="3.36" height="23.1" rx="1.68" />
        <rect :fill="color" x="82.914" y="12.6" width="3.36" height="17.64" rx="1.68" />
        <rect :fill="color" x="91.642" y="15.96" width="3.36" height="10.92" rx="1.68" />
        <rect :fill="color" x="122.189" y="13.86" width="3.36" height="15.54" rx="1.68" />
        <rect :fill="color" x="87.278" y="7.98" width="3.36" height="27.3" rx="1.68" />
        <rect :fill="color" x="126.553" y="3.78" width="3.36" height="35.7" rx="1.68" />
        <rect :fill="color" x="74.186" y=".84" width="3.36" height="41.16" rx="1.68" />
        <rect :fill="color" x="78.55" y="0" width="3.36" height="43.26" rx="1.68" />
      </g>
      <g
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
        :style="`clip-path: url(#clipPath-${contentId})`"
      >
        <circle :fill="initialColor" cx="1.68" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="6.044" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="10.408" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="45.319" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="49.683" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="54.047" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="58.411" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="67.139" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="97.686" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="102.05" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="106.414" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="110.778" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="119.505" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="145.689" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="150.053" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="167.508" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="171.872" cy="21.42" r="1.68" />
        <circle :fill="initialColor" cx="180.6" cy="21.42" r="1.68" />
        <rect :fill="initialColor" x="13.092" y="18.06" width="3.36" height="7.14" rx="1.68" />
        <rect :fill="initialColor" x="30.547" y="18.06" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="initialColor" x="39.275" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="initialColor" x="61.095" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="initialColor" x="113.461" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="initialColor" x="130.917" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="initialColor" x="139.645" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="initialColor" x="152.737" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="initialColor" x="161.464" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="initialColor" x="174.556" y="18.48" width="3.36" height="5.88" rx="1.68" />
        <rect :fill="initialColor" x="135.281" y="16.38" width="3.36" height="9.24" rx="1.68" />
        <rect :fill="initialColor" x="157.1" y="16.8" width="3.36" height="9.24" rx="1.68" />
        <rect :fill="initialColor" x="34.911" y="16.8" width="3.36" height="9.66" rx="1.68" />
        <rect :fill="initialColor" x="17.456" y="9.66" width="3.36" height="23.94" rx="1.68" />
        <rect :fill="initialColor" x="21.82" y="13.86" width="3.36" height="15.12" rx="1.68" />
        <rect :fill="initialColor" x="26.183" y="3.78" width="3.36" height="35.28" rx="1.68" />
        <rect :fill="initialColor" x="69.822" y="9.66" width="3.36" height="23.1" rx="1.68" />
        <rect :fill="initialColor" x="82.914" y="12.6" width="3.36" height="17.64" rx="1.68" />
        <rect :fill="initialColor" x="91.642" y="15.96" width="3.36" height="10.92" rx="1.68" />
        <rect :fill="initialColor" x="122.189" y="13.86" width="3.36" height="15.54" rx="1.68" />
        <rect :fill="initialColor" x="87.278" y="7.98" width="3.36" height="27.3" rx="1.68" />
        <rect :fill="initialColor" x="126.553" y="3.78" width="3.36" height="35.7" rx="1.68" />
        <rect :fill="initialColor" x="74.186" y=".84" width="3.36" height="41.16" rx="1.68" />
        <rect :fill="initialColor" x="78.55" y="0" width="3.36" height="43.26" rx="1.68" />
      </g>
    </svg>
  </div>
</template>

<script lang="ts">
import { throttle } from '@/utils/throttle';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class End extends Vue {
  @Prop({ type: Boolean }) paused!: boolean;
  @Prop({ type: Number }) progress!: number;
  @Prop({ type: Boolean }) isLeft: boolean;
  @Prop({ type: String }) contentId: string;

  pointerMove: Function;
  pointerDown: Function;
  pointerUp: Function;
  touchStart: Function;
  touchMove: Function;
  touchEnd: Function;
  moving = false;
  progressMove = {
    value: 0
  };
  startPoint:
    | undefined
    | {
        pageX: number;
      } = undefined;
  postProgressMove = throttle(() => this.$emit('progressMove', this.progressMove.value), 30);
  get color() {
    return this.isLeft ? 'var(--motif-300)' : '#FFFFFF';
  }

  get initialColor() {
    return this.isLeft ? '#C9CBD2' : '#B1A2E7';
  }

  mounted() {
    const progressEl = this.$refs.progress as HTMLDivElement;
    this.bindEvents(progressEl);
  }

  onPointerDown(e: MouseEvent | TouchEvent) {
    const position = this.getPagePosition(e);
    if (!position) return;
    this.moving = true;
    this.startPoint = {
      pageX: position.x
    };
    this.$emit('dragging', true);
  }

  onPointerMove(e: MouseEvent | TouchEvent) {
    if (!this.moving) return;
    const position = this.getPagePosition(e);
    if (!position) return;
    const progressEl = this.$refs.svg as SVGElement;
    const left = progressEl.getBoundingClientRect().left;
    const progressWidth = progressEl.clientWidth;
    const progressMove = (position.x - left) / progressWidth;
    this.progressMove.value = progressMove;
    this.postProgressMove();
  }

  onPointerUp(e: MouseEvent | TouchEvent) {
    this.moving = false;
    this.$emit('dragging', false);
  }

  bindEvents(el: HTMLDivElement) {
    this.$nextTick(() => {
      el?.addEventListener('mousedown', (this.pointerDown = this.onPointerDown.bind(this)));
      el?.addEventListener('touchstart', (this.touchStart = this.onPointerDown.bind(this)));
      document?.addEventListener('mousemove', (this.pointerMove = this.onPointerMove.bind(this)));
      document?.addEventListener('touchmove', (this.touchMove = this.onPointerMove.bind(this)));
      document.addEventListener('mouseup', (this.pointerUp = this.onPointerUp.bind(this)));
      document.addEventListener('touchend', (this.touchEnd = this.onPointerUp.bind(this)));
    });
  }

  getPagePosition(e: MouseEvent | TouchEvent): { x: number; y: number } | undefined {
    const position = {
      x: 0,
      y: 0
    };
    if (e instanceof TouchEvent) {
      if (e.changedTouches.length > 1) return;
      position.x = e.changedTouches[0].pageX;
      position.y = e.changedTouches[0].pageY;
    } else {
      position.x = e.pageX;
      position.y = e.pageY;
    }
    return position;
  }
}
</script>
